import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "reorder-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.46967 16.2297C7.76256 15.9234 8.23744 15.9234 8.53033 16.2297L12 19.857L15.4697 16.2297C15.7626 15.9234 16.2374 15.9234 16.5303 16.2297C16.8232 16.5359 16.8232 17.0323 16.5303 17.3385L12.5303 21.5203C12.2374 21.8266 11.7626 21.8266 11.4697 21.5203L7.46967 17.3385C7.17678 17.0323 7.17678 16.5359 7.46967 16.2297Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.5303 7.53033C16.2374 7.82322 15.7626 7.82322 15.4697 7.53033L12 4.06066L8.53033 7.53033C8.23744 7.82322 7.76256 7.82322 7.46967 7.53033C7.17678 7.23744 7.17678 6.76256 7.46967 6.46967L11.4697 2.46967C11.7626 2.17678 12.2374 2.17678 12.5303 2.46967L16.5303 6.46967C16.8232 6.76256 16.8232 7.23744 16.5303 7.53033Z"
    }, null, -1)
  ])))
}
export default { render: render }